import { Controller } from '@hotwired/stimulus';
import callApi from '../common/AjaxUtil';

export default class extends Controller {

  connect() { }

  async delete(event) {
    callApi(`/api/personal-notifications/${event.params.id}`, 'DELETE', { voteId: this.voteIdValue })
      .then(() => {
        location.reload();
      })
      .catch((err) => {
        window.$reloadAndSendAlert(err.msg);
      });
    }
}
